import React, { useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getForgetPassword } from "../../../service/AuthenticationService";
import { Link } from "react-router-dom";

const ForgetPassword = (props) => {
  const { logo } = props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: yup.object({
      email: yup.string().email().required(),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await getForgetPassword(values.email, (res) => {
          if (res.success === true) {
            toast.success(res.message);
            formik.resetForm();
          } else {
            toast.error(res.message);
          }
        });
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const renderEmailError = formik.touched.email && formik.errors.email && (
    <span className="errorTxt">{formik.errors.email}</span>
  );

  const url = "https://reqres.in/api/users";

  const login = async (data) => {
    const response = await axios.post(url, data);
    if ([200, 201, 202, 203, 204].includes(response.status)) {
      toast.success("Successfully");
    } else {
      toast.success("Error");
    }
  };

  return (
    <>
      <div className="loginBg">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 centerResp">
              <span className="logo">
                <img src={logo} alt="" />
              </span>
              <h2>Welcome!</h2>
              <p>
                There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="loginBase">
                <div className="text-center">
                  <h3>Forget Password</h3>
                  <h6 className="mb-5">Enter your email to reset password.</h6>
                </div>
                <form onSubmit={formik.handleSubmit}>
                  <div className="mb-4">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Email Address"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                    {renderEmailError}
                  </div>

                  <div className="loginBtn pt-3 mb-5 btnCenter">
                    {!loading ? (
                      <button type="submit" className="commonButton">
                        Proceed
                      </button>
                    ) : (
                      <button type="button" className="commonButton">
                        Processing
                        <i className="ms-2 fa-solid fa-spinner fa-spin"></i>
                      </button>
                    )}
                  </div>
                </form>

                <h6 className="btnCenter">
                  Don't have an account? <Link to="/register">Register</Link>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
